const routes = [{
  path: '/home',
  component: () => import('@/views/home'),
  name: 'home',
  meta: {
    title: '首页'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/home.js